/* Netwerkloods — filters, sortering en paginering zonder volledige paginalading (Section Rendering API). */
(function () {
  'use strict';
  if (customElements.get('facet-filters')) return;

  customElements.define('facet-filters', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.sectionId = this.dataset.sectionId;
      this.baseUrl = this.dataset.baseUrl;
      this.cache = {};
      this.debounced = window.theme.debounce(this.onFormChange.bind(this), 450);

      this.addEventListener('change', function (e) {
        if (e.target.closest('[data-facets-form]')) {
          this.debounced(e.target.closest('[data-facets-form]'), e.target);
        } else if (e.target.matches('[data-sort-select]')) {
          this.onSortChange(e.target);
        }
      }.bind(this));

      this.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-facets-form], [data-sort-form]');
        if (!form) return;
        e.preventDefault();
        if (form.matches('[data-sort-form]')) {
          this.onSortChange(form.querySelector('[data-sort-select]'));
        } else {
          this.onFormChange(form);
        }
      }.bind(this));

      this.addEventListener('click', function (e) {
        var link = e.target.closest('a[data-facet-link]');
        if (!link) return;
        e.preventDefault();
        var url = new URL(link.href, window.location.origin);
        var isPagination = !!link.closest('.pagination');
        this.render(url.search.replace(/^\?/, ''), true, isPagination);
      }.bind(this));

      this._onPop = function () {
        this.render(window.location.search.replace(/^\?/, ''), false);
      }.bind(this);
      window.addEventListener('popstate', this._onPop);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this._onPop);
    }

    currentSort() {
      var select = this.querySelector('[data-sort-select]');
      return select ? select.value : null;
    }

    paramsFromForm(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) {
        if (value === '' || value === null) return;
        params.append(key, value);
      });
      var sort = this.currentSort();
      params.delete('sort_by');
      if (sort) params.set('sort_by', sort);
      return params;
    }

    onFormChange(form) {
      this.render(this.paramsFromForm(form).toString(), true);
    }

    onSortChange(select) {
      var form = this.querySelector('[data-facets-form]');
      var params;
      if (form) {
        params = this.paramsFromForm(form);
      } else {
        params = new URLSearchParams(window.location.search);
        params.delete('page');
      }
      params.set('sort_by', select.value);
      this.render(params.toString(), true);
    }

    render(search, pushState, scroll) {
      var self = this;
      var params = new URLSearchParams(search);
      params.delete('section_id');
      var query = params.toString();
      var fetchUrl = this.baseUrl + '?' + (query ? query + '&' : '') + 'section_id=' + encodeURIComponent(this.sectionId);
      var results = this.querySelector('[data-facets-region="results"]');
      if (results) results.classList.add('is-loading');

      var openState = this.captureOpenState();
      var focusedId = document.activeElement && document.activeElement.id;

      var promise = this.cache[fetchUrl]
        ? Promise.resolve(this.cache[fetchUrl])
        : fetch(fetchUrl).then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.text();
          });

      promise
        .then(function (html) {
          self.cache[fetchUrl] = html;
          var doc = window.theme.parseHTML(html);
          self.querySelectorAll('[data-facets-region]').forEach(function (region) {
            var name = region.getAttribute('data-facets-region');
            var fresh = doc.querySelector('[data-facets-region="' + name + '"]');
            if (fresh) region.innerHTML = fresh.innerHTML;
          });
          // Filters-knop (aantal actieve filters) en sorteerselectie bijwerken.
          var freshButton = doc.querySelector('.filters-button');
          var button = self.querySelector('.filters-button');
          if (freshButton && button) button.innerHTML = freshButton.innerHTML;
          self.restoreOpenState(openState);
          if (focusedId) {
            var el = document.getElementById(focusedId);
            if (el) el.focus({ preventScroll: true });
          }
          if (pushState) {
            var url = self.baseUrl + (query ? '?' + query : '');
            history.pushState({ facets: true }, '', url);
          }
          if (scroll) {
            var top = self.getBoundingClientRect().top + window.scrollY - 160;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function () {
          // Valt terug op een gewone paginalading.
          window.location.href = self.baseUrl + (query ? '?' + query : '');
        })
        .finally(function () {
          var r = self.querySelector('[data-facets-region="results"]');
          if (r) r.classList.remove('is-loading');
        });
    }

    captureOpenState() {
      var state = {};
      this.querySelectorAll('[data-facets-form]').forEach(function (form) {
        form.querySelectorAll('details.facets__group').forEach(function (d, i) {
          state[form.id + '-' + i] = d.open;
        });
      });
      return state;
    }

    restoreOpenState(state) {
      this.querySelectorAll('[data-facets-form]').forEach(function (form) {
        form.querySelectorAll('details.facets__group').forEach(function (d, i) {
          var key = form.id + '-' + i;
          if (key in state) d.open = state[key];
        });
      });
    }
  });
})();
